import { countryCode } from 'src/app/models/countryCode';

export const CountryCodeConst: countryCode = {
  areaCodes: undefined,
  dialCode: '218',
  flagClass: 'LY',
  iso2: 'ly',
  name: 'Libya',
  placeHolder: '+218901234567',
  priority: 0
};
